import React, { Component } from 'react';
import { connect } from 'react-redux';
import OrderDetailEminPay from './OrderDetailEminPay';
import { CreditCardEminPay } from './CreditCardEminPay';
import {
    getExpensesByMemberNo,
    selectMemberExpenseByMemberNo,
    clearExpensesList
} from "../../../state/ducks/member/index";
import {
    createPaymentPayFor,
    selectPayment,
    changeCurrentPage,
    getActiveMemberNumber,
    getPaymentSum,
    selectPaymentSum,
    getActiveMemberNoList
} from "../../../state/ducks/payment/index";
import EminevimLoading from '../shared/EminevimLoading';
import { createPaymentPages } from '../../../state/ducks/payment/types';
import { EminPayBankRedirectOverlay } from './EminPayPaymentUi';
import { hideModal } from '../../../state/ducks/alert/index';
import { store } from '../../../state/store';

export class CreatePaymentOrderEminPay extends Component {

    state = {
        showBankPopup: true,
        isPageLoading: true,
        isProcessing: false,
        loadingSubtext: '',
        page: createPaymentPages.orderDetail,
        payment: {
            orderdetail: {
                memberNo: "0",
                startDate: new Date(),
                aylikTutar: "",
                aylikTutarOndalik: 0,
                installmentCount: "",
                paymentType: 1,
            },
            creditcard: {
                cardHolderName: "",
                cardNumber: "",
                expirationMonth: new Date().getMonth() + 1,
                expirationYear: new Date().getFullYear(),
                cvv: "",
                cardType: "",
                bank: "",
                bankCode: "",
                businessCard: ""
            },
            sms: {
                sms: "",
                gsm: ""
            },
        }
    };

    componentDidMount() {
        const paymentType = this.props.location?.state?.paymentType ?? 1;

        this.props.changeCurrentPage(createPaymentPages.orderDetail);
        this.props.getMemberNumber();

        Promise.all([
            this.props.getActiveMemberNo(paymentType),
        ]).finally(() => {
            this.setState({ isPageLoading: false });
        });

        this.setState(prevState => ({
            payment: {
                ...prevState.payment,
                orderdetail: {
                    ...prevState.payment.orderdetail,
                    paymentType
                }
            }
        }));
    }

    componentWillUnmount() {
        store.dispatch(hideModal());
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.page !== this.state.page && this.state.page === "sms") {
            this.setState({ showBankPopup: true, isProcessing: false });
            window.setTimeout(() => {
                this.setState({ showBankPopup: false });
            }, 4000);
        }
    }

    componentWillReceiveProps(nextProps) {
        const pageName = nextProps.payment.page;
        if (pageName != null && pageName !== "") {
            this.setState({ page: pageName });
        }
    }

    beginProcessing = (loadingSubtext) => {
        this.setState({ isProcessing: true, loadingSubtext });
    };

    endProcessing = () => {
        this.setState({ isProcessing: false, loadingSubtext: '' });
    };

    changePage = (pageName) => {
        const currPage = this.state.page;
        if (pageName === "sms") {
            this.createPaymentPayFor(currPage, pageName);
        } else {
            this.props.changeCurrentPage(pageName);
        }
    };

    loadMemberPaymentData = (memberNo, paymentType) => {
        this.beginProcessing('Üyelik bilgileri yükleniyor, lütfen bekleyiniz.');

        return Promise.all([
            this.props.getMemberExpense(memberNo, paymentType),
            this.props.getPaymentSummary(memberNo),
        ]).finally(this.endProcessing);
    };

    clearExpensesList = () => {
        this.props.clearExpensesList();
    };

    createPaymentPayFor = (currPage, pageName) => {
        const currentPage = currPage || this.state.page;
        const nextPage = pageName || createPaymentPages.sms;
        const data = this.state.payment;

        if (data.orderdetail.startDate instanceof Date) {
            data.orderdetail.startDate = data.orderdetail.startDate.toLocaleDateString("tr-TR");
        }

        this.beginProcessing('Ödeme talimatınız gönderiliyor, lütfen bekleyiniz.');

        return this.props
            .createPaymentOrder(data, currentPage, nextPage)
            .finally(this.endProcessing);
    };

    renderProcessingOverlay = () => {
        if (!this.state.isProcessing) {
            return null;
        }

        return (
            <div className="t-eminPayOrder-processingOverlay">
                <EminevimLoading subtext={this.state.loadingSubtext} compact />
            </div>
        );
    };

    renderPageLoading = () => (
        <div className="t-createPayment-page t-eminPayOrder-page" style={{ background: '#ffffff' }}>
            <div className="row" style={{ padding: '3%' }}>
                <div className="col-12">
                    <div className="t-memberInfo-pageHeader">
                        <h1 className="t-memberInfo-pageTitle">Ödeme Talimatı</h1>
                        <p className="t-memberInfo-pageSubtitle">
                            Ödeme talimatı sayfanız hazırlanıyor.
                        </p>
                    </div>
                    <div className="t-eminPayOrder-loading">
                        <EminevimLoading subtext="Ödeme talimatı sayfası hazırlanıyor, lütfen bekleyiniz." />
                    </div>
                </div>
            </div>
        </div>
    );

    render() {
        const page = this.state.page;
        const { payment } = this.props;
        const { showBankPopup, isPageLoading } = this.state;

        if (isPageLoading) {
            return this.renderPageLoading();
        }

        if (page === "sms") {
            return (
                <div className="t-createPayment-page t-eminPayOrder-page t-eminPayOrder-smsPage">
                    {showBankPopup ? <EminPayBankRedirectOverlay /> : (
                        <div className="t-eminPayOrder-smsFrameWrap">
                            <iframe
                                id="eminPay-iframe"
                                className="t-eminPayOrder-smsFrame"
                                title="Banka ödeme onayı"
                                width="100%"
                                height="640"
                                frameBorder="0"
                                srcDoc={payment?.response?.messages?.[0]}
                            />
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div className="t-eminPayOrder-shell">
                {this.renderProcessingOverlay()}

                {page === createPaymentPages.orderDetail ? (
                    <OrderDetailEminPay
                        changePage={this.changePage}
                        orderdetail={this.state.payment.orderdetail}
                        loadMemberPaymentData={this.loadMemberPaymentData}
                        expenses={this.props.expenses}
                        payment={this.props.payment}
                        clearExpensesList={this.clearExpensesList}
                    />
                ) : page === createPaymentPages.creditCard ? (
                    <CreditCardEminPay
                        changePage={this.changePage}
                        creditcard={this.state.payment.creditcard}
                        orderdetail={this.state.payment.orderdetail}
                        createPaymentPayFor={this.createPaymentPayFor}
                    />
                ) : null}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        payment: selectPayment(state),
        expenses: selectMemberExpenseByMemberNo(state),
        paymentSumData: selectPaymentSum(state),
    };
}

const mapDispatchToProps = dispatch => ({
    createPaymentOrder: (data, currPage, pageName) =>
        dispatch(createPaymentPayFor(data, currPage, pageName, { useGlobalLoading: false })),
    getMemberNumber: () => dispatch(getActiveMemberNumber()),
    getActiveMemberNo: (paymentType) => dispatch(getActiveMemberNoList(paymentType)),
    changeCurrentPage: (page) => dispatch(changeCurrentPage(page)),
    getMemberExpense: (memberNo, paymentType) => dispatch(getExpensesByMemberNo(memberNo, paymentType)),
    getPaymentSummary: (memberNo) => dispatch(getPaymentSum(memberNo, { useGlobalLoading: false })),
    clearExpensesList: () => dispatch(clearExpensesList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePaymentOrderEminPay);
